import * as React from "react";
import type { SVGProps } from "react";
const SvgAutarky = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="m11.53 2.117.47-.25.47.25 8 4.25.53.282V22H3v-3a1 1 0 0 1 2 0v1h14V7.851l-7-3.719-7 3.72V15a1 1 0 1 1-2 0V6.65l.53-.283zm1.838 7.88a1 1 0 1 0-1.736-.993l-2 3.5L8.777 14h3l-1.145 2.004a1 1 0 1 0 1.736.992l2-3.5.855-1.496h-3z"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgAutarky;
